import {
  bioGenerator,
  calcYear,
  ENVS,
  generatorYears,
  getDeviceInfoFromUserAgent,
  getParams,
  getQuery,
  getWh,
  goBack,
  hadHistory,
  isMobile,
  isSmall,
  isTextOver,
  isWx,
  mockAuth,
  openNew,
  reactiveIsMobile,
  rem,
  track,
  untrack,
  useCopy,
  useCut,
} from "../utils/tools";
import inject from "./inject";

declare global {
  interface Window {
    currentUser: any;
    appInfo: any;
    staHistory: any;
    getWh: any;
    isMobile: any;
    openNew: any;
    airborne: boolean;
    track: any;
    untrack: any;
    copy: any;
    cut: any;
    getQuery: any;
    getParams: any;
    rem: any;
    goBack: any;
    isSmall: any;
    isTextOver: any;
    bioGenerator: any;
    generatorYears: any;
    calcYear: any;
    mockAuth: any;
    vars: any;
    env: ENVS;
    reactiveIsMobile(fn: (res: boolean) => void): any;
    hadHistory: any;
    getDeviceInfoFromUserAgent: any;
    isWx: any;
    _config: {
      assets: any,
      style: any,
      text: any,
      var: any,
    };
  }
}

export default function extend() {
  const { staHistory } = inject();
  window.staHistory = staHistory;
  window.getWh = getWh;
  window.isMobile = isMobile;
  window.openNew = openNew;
  window.track = track;
  window.untrack = untrack;
  window.copy = useCopy;
  window.cut = useCut;
  window.getQuery = getQuery;
  window.getParams = getParams;
  window.rem = rem;
  window.goBack = goBack;
  window.isSmall = isSmall;
  window.isTextOver = isTextOver;
  window.bioGenerator = bioGenerator;
  window.generatorYears = generatorYears;
  window.calcYear = calcYear;
  window.mockAuth = mockAuth;
  window.reactiveIsMobile = reactiveIsMobile;
  window.hadHistory = hadHistory;
  window.getDeviceInfoFromUserAgent = getDeviceInfoFromUserAgent;
  window.isWx = isWx;
}
